import YoutubeEmbed from "../components/YoutubeEmbed";
import Divider from '@mui/material/Divider';
import { HashLink as Link } from 'react-router-hash-link';
import FloatingActionButton from "../components/FloatingActionButton";
import './MemorialService.css';

function MemorialService() {
  return (
    <div className='page'>
      <h1>A Celebration of June's Life</h1>
      <br />
      <div className="memServiceWrapperFlex">
        <p>
          June's memorial service was held on Saturday, June 10, 2023
          at Mt. Olive Lutheran Church in Santa Monica, California.
          Following the service, there was a reception in Mt.
          Olive's Parish Hall with light refreshments and the
          opportunity for persons to share their memories of June.
        </p>
      </div>
      <br />
      <Divider />
      <br/>
      <br/>
      <br/>
      <h2>Celebrating the Life of June Stephen - Memorial Service Video</h2>
      <br />
      <br />
      <div className="livestreamInfoFlex">
          <Link 
          className='link'
          to="/pdfs/Memorial_Program_-_Pages_in_Order.pdf"
          target="_blank"
          >
            Click here for a PDF of the Memorial Service program
          </Link>
          <span>(opens in new window)</span>
          <br />
          <br />
          <h3>Optional Video Settings</h3>
          <span>During playback, hover over the lower right corner of the video to access the following:
          </span>
          <ul>
            <li>Subtitles/closed captions &ndash; click the CC button to toggle on/off </li>
            <li>Video Resolution &ndash; click the gear wheel, then select Quality to change the resolution</li>
            <li>Full Screen &ndash; click the button that resembles a square with the middle missing from each side</li>
          </ul>
          <br />
        <div className="livestreamGrid">
          <YoutubeEmbed className='iframe' embedId="s4cNbN6uFgw" />
        </div>
        <br/>
        <br/>
        <br/>
        <h2>Memories of June - Reception Video*</h2>
        <span>*Subtitles/closed captions are currently auto-generated</span>
        <br />
        <div className="livestreamGrid">
          <YoutubeEmbed className='iframe' embedId="-ZiNK8pgosQ" />
        </div>
        <br />
        <br />
        <div className="embedGrid">
          <div>
            <h3>Reception Playlist</h3>
            <p>Enjoy the songs played at June's memorial reception.</p>
            <br />
            <iframe 
              title="Embedded Spotify"
              style={{borderRadius: '12px'}}
              src="https://open.spotify.com/embed/playlist/2T7izmVcx4428CdpNo6iYL?utm_source=generator&theme=0" 
              frameBorder="0" 
              allowfullscreen="" 
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
              loading="lazy"
              >
            </iframe>
            <p>To listen the playlist while viewing the slideshow, start the music first, then start the slideshow. You may need a Spotify account (free) to hear the full-length versions of the songs.</p>
          </div>
          <div>
            <h3>Reception Slideshow</h3>
            <p>To play, click on the three vertical dots below. Then select Auto-play, then Play.</p>
            <br />
            <iframe 
              title="Embedded slideshow"
              style={{borderRadius: '12px'}}
              src="https://docs.google.com/presentation/d/e/2PACX-1vTxfL_h0HMaoZiOQNc1J34V374HpmSRoJ2NUl3sL4t1oWqxCBy2AMMjBma2A7_6ab6LhFUKSumNJimi/embed?start=false&loop=true&delayms=5000" 
              frameBorder="0" 
              allowFullScreen={true} 
              mozallowfullccreen="true" 
              webkitallowfullscreen="true"
            >
            </iframe>
            <p>To view the slideshow Full Screen, click those same three vertical dots, then select Enter full screen.</p>
          </div>
        </div>
      </div>
      <div className="mtOliveFlex">
        <br />
        <h2>Mt. Olive Lutheran Church{"\n"}of Santa Monica</h2>
        <br />
        <p>
          1343 Ocean Park Blvd.{"\n"}
          Santa Monica, CA 90405
        </p>
        <p className='textTip'>
          (corner of 14th Street & Ocean Park Blvd.)
        </p>
        <p>
          {"\n"}310-452-1116{"\n"}
          <Link className='link'
            to="https://mtolivelutheranchurch.org/"
            target="_blank"
          >
                Church Website
          </Link>
        </p>
      </div>
      <div className="floatingButtonFlex">
        <div className="floatingButton">
          <FloatingActionButton showBelow={400}/>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
}


export default MemorialService;